import { useGetServicesTypesQuery } from '@/pages/Fleet/Businesses/services/services-type.service';
import { useGetVehiclesTypesQuery } from '@/pages/Fleet/Vehicles/services/vehicles-types.service';
import { useBusinesses } from '@/pages/Fleet/Businesses/hooks';
import { SelectInputOption } from '@/components/inputs/SelectInput';
import { ServiceType } from '@/pages/Fleet/Businesses/models';
import { VehicleType } from '@/pages/Fleet/Vehicles/models';
import { useMemo } from 'react';

interface UseServiceFormOptionsProps {
  includeBusinesses?: boolean;
  businessSearch?: string;
  businessPage?: number;
  businessPageSize?: number;
}

const useServiceFormOptions = (props?: UseServiceFormOptionsProps) => {
  const { includeBusinesses = false, businessSearch = '', businessPage = 1, businessPageSize = 200 } = props || {};

  const { data: vehicleTypes = [], isLoading: vehicleTypesLoading } = useGetVehiclesTypesQuery();
  const { data: serviceTypes = [], isLoading: serviceTypesLoading } = useGetServicesTypesQuery();

  const { businesses } = useBusinesses({
    search: businessSearch,
    page: businessPage,
    pageSize: businessPageSize,
  });

  const vehicleTypesOptions = useMemo<SelectInputOption[]>(() => {
    return vehicleTypes.map((type: VehicleType): SelectInputOption => ({
      value: type.id,
      label: type.name,
    }));
  }, [vehicleTypes]);

  const serviceTypesOptions = useMemo<SelectInputOption[]>(() => {
    return serviceTypes.map((type: ServiceType): SelectInputOption => ({
      value: type.id,
      label: type.name,
    }));
  }, [serviceTypes]);

  const businessOptions = useMemo<SelectInputOption[]>(() => {
    if (!includeBusinesses) return [];
    return businesses.map((business) => ({
      value: business.id,
      label: business.name,
    }));
  }, [businesses, includeBusinesses]);

  return {
    vehicleTypesOptions,
    serviceTypesOptions,
    businessOptions: includeBusinesses ? businessOptions : undefined,
    vehicleTypesLoading,
    serviceTypesLoading,
  };
};

export default useServiceFormOptions;
